import { createAction } from 'redux-actions';
import { instance } from "../../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_ADD_LOCATION');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const addLocationRequest = createAction('ADD_LOCATION_POST_REQUEST');
export const addLocationSuccess = createAction('ADD_LOCATION_POST_SUCCESS');
export const addLocationError = createAction('ADD_LOCATION_POST_ERROR');

export const addLocation = (request) => async (dispatch) => {
  try {
    dispatch(addLocationRequest());
    const resp = await instance.post(`/v1/Asset/CreateFull`, request);

    dispatch(addLocationSuccess(resp.data));
  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(addLocationError(e.response.data.description));
    else
      dispatch(addLocationError(e.message));
  }
};
